import React from "react";
import Resume from "../../views/adminView/resume";

export default function ResumePage({ update, resetUpdate }) {
    return <Resume update={update} resetUpdate={resetUpdate} />
}